/**
 * Props validation utilities - SIMPLIFIED & FLEXIBLE
 * Works with any project, minimal validation
 */

import { SmartBannerError } from "../error/SmartBannerError.js";

/**
 * Validate banner props - FLEXIBLE, accepts almost anything
 */
export function validateProps(props) {
  if (!props || typeof props !== "object") {
    throw SmartBannerError.validationError("Props must be an object");
  }

  // Just ensure basic required fields exist - very flexible
  const validated = { ...props };

  // Set defaults for missing fields
  if (!validated.place) validated.place = 1;

  // Handle both 'page' (singular) and 'pages' (plural)
  if (!validated.pages) {
    if (validated.page) {
      // Convert singular 'page' to plural 'pages'
      validated.pages = Array.isArray(validated.page)
        ? validated.page
        : [validated.page];
    } else {
      validated.pages = ["HOMEPAGE"];
    }
  } else if (!Array.isArray(validated.pages) || validated.pages.length === 0) {
    validated.pages = ["HOMEPAGE"];
  }

  if (!validated.domain) validated.domain = "DEFAULT";
  if (!validated.env) validated.env = ["DESKTOP_WEB", "MOBILE_WEB"];

  return validated;
}

/**
 * Validate container - SIMPLE
 */
export function validateContainer(container) {
  if (!container) {
    throw SmartBannerError.validationError("Container is required");
  }

  if (typeof container === "string") {
    const element = document.querySelector(container);
    if (!element) {
      throw SmartBannerError.validationError(
        `Container not found: ${container}`
      );
    }
    return element;
  }

  if (!(container instanceof HTMLElement)) {
    throw SmartBannerError.validationError(
      "Container must be a selector or HTMLElement"
    );
  }

  return container;
}

/**
 * Validate banner configs - FLEXIBLE
 */
export function validateBannerConfigs(bannerConfigs) {
  if (!Array.isArray(bannerConfigs) || bannerConfigs.length === 0) {
    throw SmartBannerError.validationError(
      "BannerConfigs must be a non-empty array"
    );
  }

  return bannerConfigs.map((config, index) => {
    if (!config || typeof config !== "object") {
      throw SmartBannerError.validationError(
        `Banner config at index ${index} must be an object`
      );
    }

    return {
      props: validateProps(config.props || {}),
      container: validateContainer(config.container),
    };
  });
}
